// Полоса вкладок сгруппированного раздела.
//
// Рендерится в Layout над страницей: если текущий маршрут принадлежит группе из
// navGroups.js — показываем вкладки группы, иначе ничего. Такой вариант выбран
// вместо layout-роутов в App.jsx намеренно: маршруты остаются как были (старые
// ссылки и закладки живы), а App.jsx не переставляется — меньше риск сломать
// lazy-загрузку страниц.
//
// Стиль полосы — тот же `tab-bar tab-bar--card`, что у раздела «Обучение и
// развитие» (components/training/TrainingShell.jsx), чтобы вкладки везде
// выглядели одинаково.
import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useModules } from '../../contexts/ModuleContext'
import { useAuth } from '../../contexts/AuthContext'
import { NAV_GROUPS, groupKeyForPathname, routeKeyFromPathname } from './navGroups'

export default function SectionTabs({ effectiveUser }) {
    const location = useLocation()
    const navigate = useNavigate()
    const { isModuleVisible } = useModules()
    const { user } = useAuth()
    const viewer = effectiveUser || user

    const groupKey = groupKeyForPathname(location.pathname)
    const activeKey = routeKeyFromPathname(location.pathname)

    const tabs = useMemo(() => {
        const group = groupKey ? NAV_GROUPS[groupKey] : null
        if (!group) return []
        return group.tabs.filter(tab => isModuleVisible(tab.moduleKey || tab.to, viewer))
    }, [groupKey, isModuleVisible, viewer])

    // Одна вкладка — полоса бессмысленна (заголовок раздела уже в шапке).
    if (tabs.length < 2) return null

    return (
        <nav className="workspace-section-tabs" aria-label="Страницы раздела">
            <div className="tab-bar">
                {tabs.map((tab) => {
                    const Icon = tab.icon
                    // Под-маршрут вкладки (например /employees/12/personnel-file)
                    // тоже подсвечивает свою вкладку.
                    const active = activeKey === tab.to || activeKey.split('/')[0] === tab.to
                    return (
                        <button
                            key={tab.to}
                            type="button"
                            className={`tab-btn${active ? ' tab-btn--active' : ''}`}
                            onClick={() => navigate(`/${tab.to}`)}
                            aria-current={active ? 'page' : undefined}
                        >
                            {Icon && <Icon size={14} />} {tab.label}
                        </button>
                    )
                })}
            </div>
        </nav>
    )
}
